var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{attrs:{"outlined":"","type":"warning","prominentborder":"left"}},[_vm._v(" IP no válida, en esta organización no tienes acceso debido a restricción de redes. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }